<template>
  <div :class="['conter']">
    <div class="title">冷暖系统选型配置</div>
    <div class="currency_suggest">
      <div class="titel">
        <span>设计依据</span>
      </div>
      <div class="title_xiao">房屋勘察情况</div>
      <div class="situation">
        <div class="demand_top">
          <div class="situat_item">
            <span class="label">户型</span>
            <span class="room_type">{{ reporInfo.house_type }}</span>
          </div>
          <div class="situat_item">
            <span class="label">规划</span>
            <span class="room_type">{{ reporInfo.house_layout }}</span>
          </div>
          <div class="situat_item">
            <span class="label">面积</span>
            <span class="room_type">{{
              reporInfo.area ? Number(reporInfo.area).toFixed(1) + "㎡" : ""
            }}</span>
          </div>
          <div class="situat_item">
            <span class="label">层高</span>
            <span class="room_type">{{
              reporInfo.floor ? Number(reporInfo.floor).toFixed(1) + "m" : ""
            }}</span>
          </div>
          <div class="situat_item" style="width: 70%">
            <span class="label">保温</span>
            <span class="room_type" style="width: auto">{{
              reporInfo.warm_state_text
            }}</span>
            <!-- <span class="room_type">中等</span> -->
          </div>
        </div>
      </div>
      <div class="title_xiao">系统定制需求</div>
      <div class="personnel">
        <div
          class="personnel_conter"
          v-for="(item, index) in reporInfo.tags"
          v-show="item.type != 3"
          :key="index"
        >
          <div class="per_laber">
            <span :class="['btn_laber', item.nameClass]">{{ item.name }}</span>
            <span
              class="eait"
              v-if="!reporInfo.bShowCard"
              @click="
                getEait(
                  item.type_desc == '' ? item.strDeas : item.type_desc,
                  item.type,
                  index
                )
              "
            ></span>
          </div>
          <div
            class="per_textar"
            v-html="item.type_desc == '' ? item.strDeas : item.type_desc"
          ></div>
        </div>
        <div class="personnel_conter">
          <div class="per_laber">
            <span :class="['btn_laber', 'five_icon']">其他需求</span>
            <span
              class="eait"
              v-if="!reporInfo.bShowCard"
              @click="getEaitOther(reporInfo.mark == '' ? '' : reporInfo.mark)"
            ></span>
          </div>
          <div class="per_textar" v-if="reporInfo.mark != ''">
            <div
              class="textea"
              :style="{ height: reporInfo.mark != '' ? 'auto' : '' }"
              v-html="
                reporInfo.mark == ''
                  ? '根据需求填写描述，若无增加可选填'
                  : reporInfo.mark
              "
            ></div>
          </div>
        </div>
      </div>
    </div>
    <div class="currency_suggest">
      <div class="titel">
        <span>系统设备选型</span>
      </div>
      <div class="title_xiao">系统设计参数</div>
      <div class="situation">
        <div class="situation_conter">
          <div class="situat_item">
            <span class="label">空调面积</span>
            <span class="room_type">{{
              reporInfo.energy_hot_area
                ? Number(reporInfo.energy_hot_area).toFixed(1) + "㎡"
                : ""
            }}</span>
          </div>
          <div class="situat_item">
            <span class="label">采暖面积</span>
            <span class="room_type">{{
              reporInfo.energy_hot_area
                ? Number(reporInfo.energy_hot_area).toFixed(1) + "㎡"
                : ""
            }}</span>
          </div>
          <div class="situat_item">
            <span class="label">需求负荷</span>
            <span class="room_type">{{
              reporInfo.energy_cold
                ? "冷" + (reporInfo.energy_cold / 1000).toFixed(1) + "kw"
                : ""
            }}</span>
          </div>
          <div class="situat_item">
            <span class="label">需求负荷</span>
            <span class="room_type">{{
              reporInfo.energy_hot
                ? "暖" + (reporInfo.energy_hot / 1000).toFixed(1) + "kw"
                : ""
            }}</span>
          </div>
          <div class="situat_item">
            <span class="label">保温情况</span>
            <span class="room_type">{{ reporInfo.warm_state }}</span>
          </div>
          <div class="situat_item">
            <span class="label">末端同开率</span>
            <span class="room_type">{{
              reporInfo.arrSub.length
                ? reporInfo.arrSub[nRoomIndex].energy_percent + "%"
                : reporInfo.sub[nRoomIndex].energy_percent
            }}</span>
          </div>
          <div class="situat_item" style="width: 70%">
            <span class="label">当地冬季平均最低气温</span>
            <span class="room_type">{{ reporInfo.temperature_avg + "℃" }}</span>
          </div>
        </div>
      </div>
      <!-- <div class="lytab" v-if="reporInfo.arrSub.length > 1">
        <div
          class="lytab_list"
          :style="{ width: reporInfo.arrSub.length < 5 ? '100%' : '' }"
        >
          <div class="arrRooms">
            <div
              :class="[
                nRoomIndex == index ? 'actRoomNav' : '',
                reporInfo.arrSub.length < 5 ? 'roomNav' : 'xRoomNav',
              ]"
              :style="{
                width:
                  reporInfo.arrSub.length < 5
                    ? 100 / reporInfo.arrSub.length + '%'
                    : '',
              }"
              v-for="(item, index) in reporInfo.arrSub"
              :key="index"
              @click="getRoom(index)"
            >
              {{ item.room | roomNumber }}
            </div>
          </div>
          <div :class="['second_nav_strip']">
            <div
              :class="[reporInfo.arrSub.length < 5 ? 'strip' : 'nostrips']"
              :style="{
                left: (100 / reporInfo.arrSub.length) * nRoomIndex + '%',
                width:
                  reporInfo.arrSub.length < 5
                    ? 100 / reporInfo.arrSub.length + '%'
                    : '',
              }"
            ></div>
          </div>
        </div>
      </div> -->
      <div class="title_xiao" v-if="reporInfo.arrSub.length">系统设备配置</div>
      <div class="confit" v-if="reporInfo.arrSub.length">
        <div class="confit_title">A.O.史密斯AI-LiNK冷暖风水专业集成系统</div>
        <div class="confit_shopp">
          <div
            class="shopp_list"
            v-for="(item, index) in reporInfo.arrSub[nRoomIndex].arrCodsystem"
            @click="getDetails(item.product_id)"
            :key="index"
          >
            <div class="shopp_img">
              <img v-lazy="item.mobile_img" alt="" />
            </div>
            <div class="shopp_text">
              <div v-if="item.new_goods_type_id!=214">{{ item.new_goods_type_name }}</div>
              <div class="item">{{ item.goods_name }}</div>
              <div class="contlav" v-if="item.new_goods_type_id!=214">
                <div
                  class="cont_list"
                  v-for="(attritem, attrindex) in item.attr_two"
                  :key="attrindex"
                >
                  <span class="cont_warp">{{ attritem.attr_name }}</span>
                  <span>{{ attritem.attr_value }}</span>
                </div>
                <!-- <div class="cont_list">
                  <span class="cont_warp">制热量</span>
                  <span>{{ attritem.attr_value + "kw" }}</span>
                </div> -->
              </div>
              <div class="contlav-type-id" v-if="item.new_goods_type_id==214">
                <div
                  class="cont_list"
                  v-for="(attritem, attrindex) in item.attr_three"
                  :key="attrindex"
                >
                  <span class="cont_warp">{{ attritem.attr_name }}</span>
                  <span>{{ attritem.attr_value }}</span>
                </div>
                <!-- <div class="cont_list">
                  <span class="cont_warp">制热量</span>
                  <span>{{ attritem.attr_value + "kw" }}</span>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <textInput
      :bShowIput.sync="bShowIput"
      :sText.sync="sText"
      :nType.sync="nType"
      :nIndex.sync="nIndex"
      :tagId.sync="tagId"
      :category.sync="category"
      @sumbit="sumbitzi"
    ></textInput>
  </div>
</template>
<script>
import textInput from "../../components/textinput/index";
export default {
  components: {
    textInput,
  },
  props: {
    reporInfo: {
      type: Object,
      default: false,
    },
  },
  data() {
    return {
      category: 0,
      nType: 0, //类型
      sText: "", //需要修改的文本
      nIndex: 0,
      bShowIput: false, //控制弹窗输入框显示隐藏
      nRoomIndex: 0,
      arrRooms: [],
      html_deas: "",
      objRoom: {}, //系统设计参数
      nHeight: 0,
      tagId: 0,
    };
  },
  mounted() {},
  filters: {
    roomNumber(index) {
      // console.log("-->计算属性", index);
      let arr = ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十"];
      if (index < 0) {
        return "地下室" + arr[Number(-index) - 1] + "层";
      } else if (index <= 10 && index > 0) {
        return arr[Number(index) - 1] + "层";
      }
    },
  },
  methods: {
    //查看商品详情
    getDetails(id) {
      this.$router.push({ path: `/shopp/details?id=${id}` });
    },
    sumbitzi(e) {
      //  console.log("sumbit", e);
      this.$emit("sumbitzi", e);
    },
    //点击编辑文本
    getEait(html_deas, type, index) {
      this.nIndex = Number(index);
      this.nType = type;
      this.sText = html_deas.replace(/<br\/>/g, "\r\n");
      this.bShowIput = true;
      //  console.log(html_deas);
    },
    getEaitOther(otherText) {
      this.nType = 0;
      this.sText = otherText.replace(/<br\/>/g, "\r\n");
      this.bShowIput = true;
    },
    getRoom(index) {
      // this.objRoom = this.reporInfo.arrSub[nRoomIndex];
      this.nRoomIndex = index;
      this.$emit("getRoom", index);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "index.scss";
</style>
